<div mat-dialog-content>
	<p>{{ data.question }}</p>
</div>

<div mat-dialog-actions>
	<button mat-button (click)="closeModal()">Cancel</button>
	<button mat-button *ngFor="let choiceBtn of data.choices" class="choice-btns" (click)="choiceSelected(choiceBtn.choice)" cdkFocusInitial color="warn">
		{{ choiceBtn.text }}
	</button>
</div>
